var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 14.4001C11.5347 14.4001 14.4001 11.5347 14.4001 8.0001C14.4001 4.46548 11.5347 1.6001 8.0001 1.6001C4.46548 1.6001 1.6001 4.46548 1.6001 8.0001C1.6001 11.5347 4.46548 14.4001 8.0001 14.4001ZM10.9658 7.36578C11.2782 7.05336 11.2782 6.54683 10.9658 6.23441C10.6534 5.92199 10.1468 5.92199 9.83441 6.23441L7.2001 8.86873L6.16578 7.83441C5.85336 7.52199 5.34683 7.52199 5.03441 7.83441C4.72199 8.14683 4.72199 8.65336 5.03441 8.96578L6.63441 10.5658C6.94683 10.8782 7.45336 10.8782 7.76578 10.5658L10.9658 7.36578Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGray);
export default __webpack_public_path__ + "static/media/check-circle-gray.20c83a65cac6d9a2a35857fd21b459b7.svg";
export { ForwardRef as ReactComponent };